import { type FlexProps, Flex } from '@/ui';
import { Logo } from '../Logo';

type Props = FlexProps & {
  fullWidth?: boolean;
  hideLogo?: boolean;
  header: JSX.Element;
  onSubmit: () => void;
};

export const AuthFormStack = ({
  header,
  hideLogo,
  fullWidth,
  children,
  ...props
}: Props) => {
  return (
    <Flex
      as="form"
      direction="column"
      gap="6"
      // Phone widths follow the container rather than the viewport: this stack
      // renders inside AuthLayout's padded container, so a 100vw form hung off
      // the right edge by that padding, clipped rather than scrollable. maxW
      // keeps the wider fixed size honest in any container narrower than it.
      maxW="100%"
      noValidate
      textAlign="center"
      w={fullWidth ? '100%' : { base: '100%', sm: '380px' }}
      {...props}
    >
      {!hideLogo && <Logo mx="auto" width={60} />}

      {header}

      <Flex direction="column" gap="3">
        {children}
      </Flex>
    </Flex>
  );
};
